import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { formatDate } from 'date-fns'
import { ParticipacaoSocietariaRow } from 'src/modules/motor-credito/serasa/serasa.pf.types'

export type ParticipacaoSocietariaProps = {
    participacoes: ParticipacaoSocietariaRow[]
}

const participacaoSocietariaColumns = static_build_participacao_societaria_columns()

export default function ParticipacaoSocietaria({ participacoes }: ParticipacaoSocietariaProps) {
    if (participacoes && participacoes.length) {
        return (
            <>
                <Divider textAlign="center">Participação Societária</Divider>

                <Grid
                    container
                    spacing={1}
                    sx={{
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 5,
                        paddingRight: 5
                    }}
                >
                    <Grid size={12}>
                        <DataGrid
                            rows={participacoes || []}
                            columns={participacaoSocietariaColumns}
                            getRowId={static_getRowId}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10
                                    }
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </>
        )
    }
    return <></>
}

function static_getRowId(row: ParticipacaoSocietariaRow) {
    return row.cnpj
}

function static_build_participacao_societaria_columns(): GridColDef[] {
    return [
        {
            field: 'empresa',
            headerName: 'Empresa',
            width: 300
        },
        {
            field: 'cnpj',
            headerName: 'CNPJ',
            width: 100
        },
        {
            field: 'participacao',
            headerName: 'Participação',
            width: 50
        },
        {
            field: 'uf',
            headerName: 'UF',
            width: 50
        },
        {
            field: 'desde',
            headerName: 'Desde',
            valueGetter(_value, row) {
                return formatDate(row.desde, 'dd/MM/yyyy')
            },
            width: 100
        }
    ]
}
